import { ControlledTransactions as Component } from './component';
import Connector from './connector';
import { ConnectorControlledTransactionsProps } from './ControlledTransaction.proptype';

export interface ControlledTransactionsProps extends Omit<ConnectorControlledTransactionsProps, 'component'> {}

export const ControlledTransactions = (props: ControlledTransactionsProps) => (
  <Connector {...props} component={Component} />
);
